/*
 * ALLPOWERS US – Global Tiered Free Gift
 * Version: 1.4.0 SAFE
 *
 * $1,200–$1,599.99 -> SP-001
 * $1,600–$2,199.99 -> P100
 * $2,200+           -> SE60
 *
 * SAFE RULES:
 * - Only manages the free-gift cart logic and its small status card.
 * - No MutationObserver.
 * - Does not modify header, images, sliders, sections or product cards.
 * - Does not replace window.fetch.
 * - Uses the Impact theme's native cart events to refresh/open the drawer.
 */

(function () {
  'use strict';

  if (window.AP_US_TIERED_GIFT_LOADED_V14) return;
  window.AP_US_TIERED_GIFT_LOADED_V14 = true;

  const CONFIG = {
    enabled: true,
    currency: 'USD',
    locale: 'en-US',

    giftProperty: '_ap_us_free_gift',
    giftTierProperty: '_ap_us_gift_tier',
    giftNameProperty: '_ap_us_gift_name',

    tiers: [
      {
        threshold: 120000,
        variantId: 45058752217241,
        name: 'SP-001',
        label: 'Portable Foldable Solar Panel SP-001'
      },
      {
        threshold: 160000,
        variantId: 45620151582873,
        name: 'P100',
        label: 'P100 Power Bank'
      },
      {
        threshold: 220000,
        variantId: 46089798910105,
        name: 'SE60',
        label: 'Laminated Integrated Solar Panel SE-60'
      }
    ],

    text: {
      heading: 'Your Free Gift',
      unlocked: 'free gift unlocked',
      highestUnlocked: 'Highest gift tier unlocked',
      spendMore: 'Spend',
      more: 'more to unlock',
      firstGift: 'your first free gift',
      oneGift: 'One gift per qualifying order.'
    }
  };

  const nativeFetch = window.fetch.bind(window);

  let isProcessing = false;
  let pendingCheck = false;
  let debounceTimer = null;
  let lastCart = null;

  function rootUrl(path) {
    const root =
      (window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root) || '/';

    return root.replace(/\/$/, '') + '/' +
      String(path || '').replace(/^\//, '');
  }

  async function fetchJSON(url, options) {
    const response = await nativeFetch(url, options);

    if (!response.ok) {
      let detail = '';

      try {
        detail = await response.text();
      } catch (e) {}

      throw new Error(
        'Shopify request failed (' +
          response.status +
          '): ' +
          detail
      );
    }

    return response.json();
  }

  async function getCart() {
    return fetchJSON(
      rootUrl('cart.js') + '?ap_gift_ts=' + Date.now(),
      {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Cache-Control': 'no-cache'
        },
        credentials: 'same-origin',
        cache: 'no-store'
      }
    );
  }

  function isManagedGift(item) {
    return !!(
      item &&
      item.properties &&
      String(item.properties[CONFIG.giftProperty]) === '1'
    );
  }

  /*
   * Robust line subtotal:
   * Different Shopify cart/event payloads may expose different price fields.
   * We always prefer the original pre-discount line price.
   */
  function getOriginalLinePrice(item) {
    if (!item) return 0;

    const qty = Number(item.quantity || 0);

    const candidates = [
      item.original_line_price,
      item.line_price,
      item.final_line_price
    ];

    for (const candidate of candidates) {
      const value = Number(candidate);
      if (Number.isFinite(value) && value > 0) {
        return value;
      }
    }

    const unitCandidates = [
      item.original_price,
      item.price,
      item.final_price
    ];

    for (const candidate of unitCandidates) {
      const value = Number(candidate);
      if (Number.isFinite(value) && value > 0 && qty > 0) {
        return value * qty;
      }
    }

    return 0;
  }

  function qualifyingSubtotal(cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;

    return cart.items.reduce(function (total, item) {
      if (isManagedGift(item)) return total;
      return total + getOriginalLinePrice(item);
    }, 0);
  }

  function targetTierFor(subtotal) {
    let target = null;

    CONFIG.tiers.forEach(function (tier) {
      if (subtotal >= tier.threshold) {
        target = tier;
      }
    });

    return target;
  }

  function nextTierFor(subtotal) {
    return (
      CONFIG.tiers.find(function (tier) {
        return subtotal < tier.threshold;
      }) || null
    );
  }

  async function changeLine(lineKey, quantity) {
    return fetchJSON(rootUrl('cart/change.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        id: lineKey,
        quantity: quantity
      })
    });
  }

  async function addGift(tier) {
    const properties = {};

    properties[CONFIG.giftProperty] = '1';
    properties[CONFIG.giftTierProperty] =
      String(tier.threshold / 100);
    properties[CONFIG.giftNameProperty] = tier.name;

    return fetchJSON(rootUrl('cart/add.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: [
          {
            id: tier.variantId,
            quantity: 1,
            properties: properties
          }
        ]
      })
    });
  }

  async function removeLines(lines) {
    for (const item of lines) {
      await changeLine(item.key, 0);
    }
  }

  function money(cents) {
    try {
      return new Intl.NumberFormat(CONFIG.locale, {
        style: 'currency',
        currency: CONFIG.currency,
        minimumFractionDigits: 2
      }).format((Number(cents) || 0) / 100);
    } catch (e) {
      return '$' +
        ((Number(cents) || 0) / 100).toFixed(2);
    }
  }

  function progressPercent(subtotal) {
    const tiers = CONFIG.tiers;
    const highest = tiers[tiers.length - 1].threshold;

    if (subtotal <= 0) return 0;
    if (subtotal >= highest) return 100;

    let lower = 0;
    let upper = tiers[0].threshold;
    let segmentIndex = 0;

    for (let i = 0; i < tiers.length; i++) {
      if (subtotal < tiers[i].threshold) {
        upper = tiers[i].threshold;
        lower = i === 0 ? 0 : tiers[i - 1].threshold;
        segmentIndex = i;
        break;
      }
    }

    const segmentWidth = 100 / tiers.length;
    const local = Math.max(
      0,
      Math.min(
        1,
        (subtotal - lower) / (upper - lower)
      )
    );

    return Math.min(
      100,
      segmentIndex * segmentWidth +
        local * segmentWidth
    );
  }

  function escapeHTML(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function buildStatusMarkup(cart) {
    const subtotal = qualifyingSubtotal(cart);
    const current = targetTierFor(subtotal);
    const next = nextTierFor(subtotal);

    let message = '';
    let secondary = '';

    if (!current) {
      const first = CONFIG.tiers[0];
      const remaining = Math.max(
        0,
        first.threshold - subtotal
      );

      message =
        '<strong>' +
        CONFIG.text.spendMore +
        ' ' +
        money(remaining) +
        ' ' +
        CONFIG.text.more +
        ' ' +
        CONFIG.text.firstGift +
        '.</strong>';

      secondary =
        'At ' +
        money(first.threshold) +
        ': <strong>' +
        escapeHTML(first.label) +
        '</strong> free.';
    } else if (next) {
      const remaining = Math.max(
        0,
        next.threshold - subtotal
      );

      message =
        '<strong>🎁 ' +
        escapeHTML(current.label) +
        ' ' +
        CONFIG.text.unlocked +
        '.</strong>';

      secondary =
        CONFIG.text.spendMore +
        ' ' +
        money(remaining) +
        ' ' +
        CONFIG.text.more +
        ': <strong>' +
        escapeHTML(next.label) +
        '</strong>.';
    } else {
      message =
        '<strong>🎁 ' +
        escapeHTML(current.label) +
        ' – ' +
        CONFIG.text.highestUnlocked +
        '.</strong>';

      secondary = CONFIG.text.oneGift;
    }

    return (
      '<div class="ap-us-tiered-gift-status" data-ap-us-tiered-gift-status>' +
        '<div class="ap-us-tiered-gift-status__top">' +
          '<span class="ap-us-tiered-gift-status__title">' +
            CONFIG.text.heading +
          '</span>' +
          '<span class="ap-us-tiered-gift-status__amount">' +
            money(subtotal) +
          '</span>' +
        '</div>' +
        '<div class="ap-us-tiered-gift-progress" aria-hidden="true">' +
          '<span class="ap-us-tiered-gift-progress__fill" style="width:' +
            progressPercent(subtotal).toFixed(2) +
            '%"></span>' +
        '</div>' +
        '<div class="ap-us-tiered-gift-status__message">' +
          message +
        '</div>' +
        '<div class="ap-us-tiered-gift-status__next">' +
          secondary +
        '</div>' +
      '</div>'
    );
  }

  function renderStatus(cart) {
    if (!cart) return;

    const drawerFooter =
      document.querySelector(
        '#cart-drawer [slot="footer"]'
      );

    if (drawerFooter) {
      const oldDrawerStatus =
        drawerFooter.querySelector(
          '[data-ap-us-tiered-gift-status]'
        );

      if (oldDrawerStatus) {
        oldDrawerStatus.remove();
      }

      drawerFooter.insertAdjacentHTML(
        'afterbegin',
        buildStatusMarkup(cart)
      );
    }

    const cartForm =
      document.querySelector(
        '.shopify-section--main-cart .cart-form'
      );

    if (cartForm) {
      const oldCartStatus =
        cartForm.querySelector(
          '[data-ap-us-tiered-gift-status]'
        );

      if (oldCartStatus) {
        oldCartStatus.remove();
      }

      cartForm.insertAdjacentHTML(
        'afterbegin',
        buildStatusMarkup(cart)
      );
    }
  }

  /*
   * Ask the Impact theme to refresh the drawer from Shopify.
   * We do not rewrite the drawer HTML ourselves.
   */
  function requestThemeCartRefresh() {
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:refresh', {
        bubbles: true
      })
    );
  }

  /*
   * Open the Impact cart drawer using its native event first.
   * The theme's cart-drawer.js listens for `variant:add`.
   *
   * A direct .show() call remains only as a fallback.
   */
  function openCartDrawerNative(cart) {
    try {
      if (
        !window.themeVariables ||
        !window.themeVariables.settings ||
        window.themeVariables.settings.cartType !== 'drawer'
      ) {
        return;
      }

      document.documentElement.dispatchEvent(
        new CustomEvent('variant:add', {
          bubbles: true,
          detail: {
            items: [],
            cart: cart || lastCart || {}
          }
        })
      );

      window.setTimeout(function () {
        const drawer =
          document.querySelector('#cart-drawer');

        if (
          drawer &&
          typeof drawer.show === 'function' &&
          !drawer.hasAttribute('open')
        ) {
          drawer.show();
        }
      }, 80);
    } catch (error) {
      console.warn(
        '[ALLPOWERS US Tiered Gift] Drawer open skipped.',
        error
      );
    }
  }

  async function reconcileGift(options) {
    options = options || {};

    if (!CONFIG.enabled) return null;

    /*
     * Extra safety for Impact's line-item loader.
     * If a native quantity/remove action is still busy, postpone our sync
     * instead of touching the drawer while the theme is mid-transition.
     */
    if (
      document.querySelector(
        '#cart-drawer line-item pill-loader[aria-busy="true"]'
      )
    ) {
      scheduleGiftCheck(
        350,
        options
      );
      return lastCart;
    }

    if (isProcessing) {
      pendingCheck = true;
      return lastCart;
    }

    isProcessing = true;

    document.documentElement.classList.add(
      'ap-us-tiered-gift-syncing'
    );

    let changed = false;

    try {
      let cart = await getCart();

      const subtotal = qualifyingSubtotal(cart);
      const targetTier = targetTierFor(subtotal);
      let managed = cart.items.filter(isManagedGift);

      if (!targetTier) {
        if (managed.length > 0) {
          await removeLines(managed);
          changed = true;
          cart = await getCart();
        }

        lastCart = cart;

        if (changed) {
          requestThemeCartRefresh();
          await wait(250);
        }

        renderStatus(cart);

        if (options.openDrawer) {
          openCartDrawerNative(cart);
        }

        return cart;
      }

      const wrong =
        managed.filter(function (item) {
          return (
            Number(item.variant_id) !==
            Number(targetTier.variantId)
          );
        });

      if (wrong.length > 0) {
        await removeLines(wrong);
        changed = true;
        cart = await getCart();
      }

      let correct =
        cart.items.filter(function (item) {
          return (
            isManagedGift(item) &&
            Number(item.variant_id) ===
              Number(targetTier.variantId)
          );
        });

      if (correct.length > 1) {
        await removeLines(correct.slice(1));
        changed = true;
        cart = await getCart();

        correct =
          cart.items.filter(function (item) {
            return (
              isManagedGift(item) &&
              Number(item.variant_id) ===
                Number(targetTier.variantId)
            );
          });
      }

      if (correct.length === 0) {
        await addGift(targetTier);
        changed = true;
        cart = await getCart();
      } else if (
        Number(correct[0].quantity) !== 1
      ) {
        await changeLine(
          correct[0].key,
          1
        );

        changed = true;
        cart = await getCart();
      }

      lastCart = cart;

      if (changed) {
        requestThemeCartRefresh();

        /*
         * The Impact drawer refresh is asynchronous.
         * Give it a short moment to replace its server-rendered contents.
         */
        await wait(300);
      }

      renderStatus(cart);

      if (options.openDrawer) {
        openCartDrawerNative(cart);
      }

      return cart;
    } catch (error) {
      console.error(
        '[ALLPOWERS US Tiered Gift]',
        error
      );

      return lastCart;
    } finally {
      isProcessing = false;

      document.documentElement.classList.remove(
        'ap-us-tiered-gift-syncing'
      );

      if (pendingCheck) {
        pendingCheck = false;

        window.setTimeout(function () {
          reconcileGift();
        }, 180);
      }
    }
  }

  function wait(ms) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, ms);
    });
  }

  function scheduleGiftCheck(
    delay,
    options
  ) {
    window.clearTimeout(debounceTimer);

    debounceTimer =
      window.setTimeout(function () {
        reconcileGift(options);
      }, delay || 250);
  }

  /*
   * Native Impact cart changes.
   * Product-form already opens the drawer itself,
   * so we only reconcile the gift here.
   */
  document.addEventListener(
    'cart:change',
    function (event) {
      if (isProcessing) {
        return;
      }

      const baseEvent =
        event &&
        event.detail &&
        event.detail.baseEvent
          ? String(event.detail.baseEvent)
          : '';

      /*
       * Impact theme removes a line item in two phases:
       * 1) line item animation (~200ms)
       * 2) cart drawer inner HTML refresh (1250ms for non-variant:add changes)
       *
       * Running our gift refresh inside that window can replace the drawer
       * while the theme is still finishing its own removal animation, leaving
       * the pill-loader stuck in a busy state.
       *
       * Therefore:
       * - quantity/remove changes wait until Impact has completely finished;
       * - native product-form additions can be checked quickly.
       */
      if (baseEvent === 'line-item:change') {
        scheduleGiftCheck(1450);
        return;
      }

      if (baseEvent === 'variant:add') {
        scheduleGiftCheck(250);
        return;
      }

      scheduleGiftCheck(650);
    }
  );

  /*
   * Existing custom ALLPOWERS sections dispatch this event
   * after their direct /cart/add.js call.
   *
   * Here we:
   * 1) fetch the REAL latest Shopify cart,
   * 2) add/swap the correct gift,
   * 3) refresh the native Impact drawer,
   * 4) open the native drawer.
   */
  document.addEventListener(
    'cart:updated',
    function () {
      if (!isProcessing) {
        scheduleGiftCheck(
          80,
          { openDrawer: true }
        );
      }
    }
  );

  /*
   * Some legacy custom code dispatches cart:refresh on window.
   */
  window.addEventListener(
    'cart:refresh',
    function () {
      if (!isProcessing) {
        scheduleGiftCheck(
          120,
          { openDrawer: true }
        );
      }
    }
  );

  /*
   * After the theme refreshes its drawer, restore only our
   * small status card from the latest real cart.
   */
  document.addEventListener(
    'cart:refresh',
    function () {
      if (!lastCart) return;

      window.setTimeout(function () {
        renderStatus(lastCart);
      }, 380);
    }
  );

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        scheduleGiftCheck(250);
      },
      { once: true }
    );
  } else {
    scheduleGiftCheck(250);
  }

  window.addEventListener(
    'pageshow',
    function () {
      scheduleGiftCheck(250);
    }
  );

  /*
   * Debug helpers:
   *
   * AP_US_TIERED_GIFT.debug()
   * AP_US_TIERED_GIFT.refresh()
   * AP_US_TIERED_GIFT.open()
   */
  window.AP_US_TIERED_GIFT = {
    refresh: function () {
      return reconcileGift();
    },

    open: async function () {
      const cart = await getCart();
      lastCart = cart;
      renderStatus(cart);
      openCartDrawerNative(cart);
      return cart;
    },

    debug: async function () {
      const cart = await getCart();

      const rows = (cart.items || []).map(
        function (item) {
          return {
            title: item.product_title || item.title,
            variant_id: item.variant_id,
            quantity: item.quantity,
            original_line_price: item.original_line_price,
            line_price: item.line_price,
            final_line_price: item.final_line_price,
            original_price: item.original_price,
            price: item.price,
            final_price: item.final_price,
            managed_gift: isManagedGift(item)
          };
        }
      );

      const result = {
        cart: cart,
        qualifyingSubtotalCents:
          qualifyingSubtotal(cart),
        qualifyingSubtotal:
          money(qualifyingSubtotal(cart)),
        targetTier:
          targetTierFor(
            qualifyingSubtotal(cart)
          ),
        items: rows
      };

      console.table(rows);
      console.log(
        '[ALLPOWERS US Gift Debug]',
        result
      );

      return result;
    },

    config: CONFIG
  };
})();
